import { trackAnalyticsNew } from '../../../../lib/utils';

export const getGlobalNavigationAnalytics = ({
  analyticsSlug,
  url,
}) => trackAnalyticsNew({
  url,
  location: 'page:header',
  name: analyticsSlug,
});
